import config from '../../config';
import {
  goTo,
} from '../../actions/routing';
import { parseQueryString } from '../../utils/queryString';
import { muleSoftFetch } from '../../utils/fetch';
 
export const EMMA_RESET_SUCCESS = 'EMMA_RESET_SUCCESS';
export const EMMA_RESET_FAIL = 'EMMA_RESET_FAIL';
export const EMMA_REACTIVATE_ACCOUNT_PENDING = 'EMMA_REACTIVATE_ACCOUNT_PENDING';
export const EMMA_REACTIVATE_ACCOUNT_SUCCESS = 'EMMA_REACTIVATE_ACCOUNT_SUCCESS';
const EMMA_SUBMIT_PENDING = 'EMMA_SUBMIT_PENDING';
const EMMA_SERVER_REQUEST_PENDING = 'EMMA_SERVER_REQUEST_PENDING';
const EMMA_SERVER_REQUEST_COMPLETE = 'EMMA_SERVER_REQUEST_COMPLETE';

const initialState = {
  method: 'email',
  password: '',
  verifyTokenComplete: false,
  isSubmitting: false,
  isReactivatingAccount: false,
  isLoading: false,
  isResetSuccess: false,
  errorCode: '',
  email: '',
  countryCode: '',
  mobile: '',
  selectType: '',
  payload: {},
  token: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case EMMA_SUBMIT_PENDING:
      return {
        ...state,
      };
    case EMMA_SERVER_REQUEST_PENDING:
      return {
        ...state,
        isLoading: true,
        isSubmitting: true,
      };
    case EMMA_SERVER_REQUEST_COMPLETE:
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
      };
    case EMMA_RESET_SUCCESS:
      return {
        ...state,
        isResetSuccess: true,
        email: action.email,
        countryCode: action.countryCode,
        mobile: action.mobile,
        selectType: action.selectType,
      };
    case EMMA_RESET_FAIL:
      return {
        ...state,
        isResetSuccess: false,
        isSubmitting: false,
        errorCode: action.errorCode || '',
        email: action.email,
        countryCode: action.countryCode,
        mobile: action.mobile,
        selectType: action.selectType,
        payload: action.payload,
        token: action.token,
      };
    case EMMA_REACTIVATE_ACCOUNT_PENDING:
      return {
        ...state,
        isReactivatingAccount: true,
      };
    case EMMA_REACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        isReactivatingAccount: false,
      };
    default:
      return state;
  }
}

export function submitEmailForForgetPwd(submitValues, fromPage = '') {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EMMA_SUBMIT_PENDING,
    });

    dispatch({
      type: EMMA_SERVER_REQUEST_PENDING,
    });

    const postBody = {
      resetUserCredentials: {
        featureName: 'password',
        locale: currLang || 'en',
        contactType: submitValues.selectType,
        captchaToken: submitValues.captchaToken,
        ...submitValues.selectType === 'email' ? { email: submitValues.email.toLowerCase() } :
          {
            countryCode: submitValues.countryCode,
            mobile: submitValues.mobile,
          },
      },
    };

    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };

    await muleSoftFetch(`${config.webview.muleApiBaseUrl}/customers/forgot`, 'post', postBody, option)
      .then(() => {
        dispatch({
          type: EMMA_SERVER_REQUEST_COMPLETE,
        });
        dispatch({
          type: EMMA_RESET_SUCCESS,
          email: submitValues.email,
          countryCode: submitValues.countryCode,
          mobile: submitValues.mobile,
          selectType: submitValues.selectType,
        });
        dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/password/setup-acc-success`));
      }).catch((error) => {
        dispatch({
          type: EMMA_SERVER_REQUEST_COMPLETE,
        });
        if (error.response) {
          dispatch({
            type: EMMA_RESET_FAIL,
            errorCode: error.response.data.response.reasonCode,
            email: submitValues.email,
            countryCode: submitValues.countryCode,
            mobile: submitValues.mobile,
            payload: error.response.data.response.payload,
            selectType: submitValues.selectType,
          });
          dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/password/setup-acc-fail?fromPage=${encodeURIComponent(fromPage)}`));
        } else {
          dispatch({
            type: EMMA_RESET_FAIL,
            errorCode: 'NWK',
            email: '',
            countryCode: '',
            mobile: '',
            selectType: '',
          });
          dispatch(goTo(`${currLang}/${config.webview.identityFEPath}/emma/forget/password/setup-acc-fail?fromPage=${encodeURIComponent(fromPage)}`));
        }
      });
  };
}

export function sumbitReactivateUserAccount(isPo, captchaToken) {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const { email, countryCode, mobile, selectType, token } = getState().emmaForgetPassword;
    const contactParam = selectType === 'email' ? {
      email: email.toLowerCase(),
      contactType: selectType,
    } : {
      countryCode,
      mobile,
      contactType: selectType,
    };

    const tokenParam = {
      token,
    };

    const formData = {
      locale: currLang || 'en',
      ...token && token !== '' ? tokenParam : contactParam,
      captchaToken: captchaToken || '',
    };

    dispatch({
      type: EMMA_REACTIVATE_ACCOUNT_PENDING,
    });

    dispatch({
      type: EMMA_SERVER_REQUEST_PENDING,
    });

    const queryParams = {
      featureName: isPo ? 'reactivateuserPO' : 'reactivateuserCWP',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(
      parseQueryString(`${config.webview.muleApiBaseUrl}/customers/registration`, queryParams),
      'post',
      { registrationRequest: formData },
      option
    ).then(() => {
        dispatch({
          type: EMMA_SERVER_REQUEST_COMPLETE,
        });
        dispatch({
          type: EMMA_REACTIVATE_ACCOUNT_SUCCESS,
        });
        dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/password/acc-reactivate-success`));
      }).catch(() => {
        dispatch({
          type: EMMA_SERVER_REQUEST_COMPLETE,
        });
        dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/emma/forget/password/acc-reactivate-fail`));
      });
  };
}


export const emmaSubmitResetPassword = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const body = {
      'updatePasswordRequest': {
        'token': submitValues.token,
        'password': submitValues.password,
      },
    };

    dispatch({
      type: EMMA_SUBMIT_PENDING,
    });

    dispatch({
      type: EMMA_SERVER_REQUEST_PENDING,
    });

    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(`${config.webview.muleApiBaseUrl}/customers/verifications`, 'post', body, option)
      .then(() => {
        dispatch({
          type: EMMA_SERVER_REQUEST_COMPLETE,
        });
        dispatch({
          type: EMMA_RESET_SUCCESS,
          userEmail: '',
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/password/reset-success`));
      }).catch((error) => {
        dispatch({
          type: EMMA_SERVER_REQUEST_COMPLETE,
        });
        if (error.response) {
          dispatch({
            type: EMMA_RESET_FAIL,
            errorCode: error.response.data.code,
            payload: error.response.data.payload,
            token: submitValues.token,
          });
        } else {
          dispatch({
            type: EMMA_RESET_FAIL,
            errorCode: 'NWK',
          });
        }
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/emma/forget/password/reset-fail?fromPage=${encodeURIComponent(fromPage)}`));
      });
  };
};
